import React, { Component, Fragment } from "react";
import "./Messages.scss";
import { MuiThemeProvider } from "@material-ui/core";

class Messages extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    // console.log(this.props.messageDivVisibility)
    // console.log(this.props.messageType)
    return (
      <Fragment>
        <div
          className={
            this.props.messageDivVisibility === "visible"
              ? "messagesDivShow"
              : "messagesDivHide"
          }
          style={
            this.props.messageFunction === "Browser"
              ? { backgroundColor: "white" }
              : null
          }
        >
          <div className={`messageDivHeader${this.props.messageType}`}>
            {this.props.messageType === "Success" ? (
              <h1>Message</h1>
            ) : this.props.messageType === "Warning" ? (
              <h1>Warning</h1>
            ) : this.props.messageType === "Error" ? (
              <h1>Error</h1>
            ) : (
              <h1>Alert</h1>
            )}
          </div>
          <div className="messageDivMessage">
            <h1>{this.props.messageMessage}</h1>
            {this.props.messageFunction === "resetEngagement" ? (
              <form>
                <input
                  type="password"
                  id="pass"
                  name="pass"
                  onChange={e => this.props.passInput(e)}
                />
              </form>
            ) : null}
          </div>
          <div className="flex flex-justify-end">
            {this.props.messageFunction === "Logout" ? (
              <Fragment>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.logoutYes(e)}
                >
                  Ok
                </button>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.closeMessage(e)}
                >
                  Cancel
                </button>
              </Fragment>
            ) : this.props.messageFunction === "submitDistrict" ? (
              <Fragment>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.onDistrictSubmitHandler(e)}
                >
                  Ok
                </button>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.closeMessage(e)}
                >
                  Cancel
                </button>
              </Fragment>
            ) : this.props.messageFunction === "submitCity" ? (
              <Fragment>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.onCitySubmitHandler(e)}
                >
                  Ok
                </button>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.closeMessage(e)}
                >
                  Cancel
                </button>
              </Fragment>
            ) : this.props.messageFunction === "submitEngagement" ? (
              <Fragment>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.onEngagementSubmitHandler(e)}
                >
                  Ok
                </button>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.closeMessage(e)}
                >
                  Cancel
                </button>
              </Fragment>
            ) : this.props.messageFunction === "Advance" ? (
              <Fragment>
                <button
                  className="messageDivButtons"
                  id={this.props.advanceId}
                  name={this.props.advanceName}
                  skey={this.props.advanceSkey}
                  onClick={e => this.props.advanceGame(e)}
                >
                  Ok
                </button>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.closeMessage(e)}
                >
                  Cancel
                </button>
              </Fragment>
            ) : this.props.messageFunction === "resetEngagement" ? (
              <Fragment>
                <button
                   className={this.props.engageOk ? "messageDivButtons" : "disabledEngagementButton"}
                  id={this.props.engagementResetId}
                  onClick={e => this.props.resetEngagement(e)}
                  disabled={!this.props.engageOk}
                >
                  Ok
                </button>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.closeMessage(e)}
                >
                  Cancel
                </button>
              </Fragment>
            ) : this.props.messageFunction === "resetCity" ? (
              <Fragment>
                <button
                  className="messageDivButtons"
                  id={this.props.resetId}
                  name={this.props.resetName}
                  skey={this.props.resetSkey}
                  onClick={e => this.props.resetCity(e)}
                >
                  Ok
                </button>
                <button
                  className="messageDivButtons"
                  onClick={e => this.props.closeMessage(e)}
                >
                  Cancel
                </button>
              </Fragment>
            ) : (
              <button
                className="messageDivButtons"
                onClick={e => this.props.closeMessage(e)}
              >
                Ok
              </button>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Messages;
